import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollWindowToTop = (behavior = "smooth") => {
  window.scrollTo({ top: 0, left: 0, behavior });

  if (behavior === "auto" && typeof document !== "undefined") {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
};

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    scrollWindowToTop(prefersReducedMotion ? "auto" : "smooth");
  }, [location.pathname, location.search]);

  return null;
};

export default ScrollToTop;
